<template>
    <div class="text-center mt-9">
        <div>
            <i class="bi bi-x-octagon-fill text-danger" style="font-size: 100px;"></i>
        </div>
        <div>
            <h3>Giriş qadağandır</h3>
        </div>
        <div>
            <h6>Sizin bu səhifəyə baxmaq icazəniz yoxdur.</h6>
            <h6>
                Lütfən, etimadnaməsini yoxlayın və yenidən cəhd edin.</h6>
        </div>
    </div>
</template>
<script>
import 'bootstrap-icons/font/bootstrap-icons.css';
export default {}
</script>